import { render, staticRenderFns } from "./StoresList.vue?vue&type=template&id=f5a5574c&"
import script from "./StoresList.vue?vue&type=script&lang=js&"
export * from "./StoresList.vue?vue&type=script&lang=js&"
import style0 from "./StoresList.vue?vue&type=style&index=0&id=f5a5574c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./StoresList.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Fcdnjs.cloudflare.com%2Fajax%2Flibs%2Ffont-awesome%2F5.15.4%2Fcss%2Fall.min.css"
if (typeof block0 === 'function') block0(component)

export default component.exports